import { TaskStatus } from './types';

type ShadowVariant = 'blue' | 'orange' | 'mint' | 'green' | 'grey' | 'red';

type StatusConfigItem = {
  badgeColor: string;
  badgeText: string;
  statusColor: string;
  shadowVariant: ShadowVariant;
  borderColor: string;
};

export const STATUS_CONFIG: Record<TaskStatus, StatusConfigItem> = {
  claimed: { badgeColor: 'tw-bg-[#20AA67]', badgeText: 'Claimed', statusColor: 'tw-text-[#20AA67]', shadowVariant: 'green', borderColor: '#20AA67' },
  in_distribution: { badgeColor: 'tw-bg-[#FF8000]', badgeText: 'In Distribution', statusColor: 'tw-text-[#20AA67]', shadowVariant: 'orange', borderColor: '#FF8000' },
  expired: { badgeColor: 'tw-bg-[#F83A56]', badgeText: 'Expired', statusColor: 'tw-text-[#F83A56]', shadowVariant: 'red', borderColor: '#F83A56' },
  distributed: { badgeColor: 'tw-bg-[#20AA67]', badgeText: 'Distributed', statusColor: 'tw-text-white', shadowVariant: 'green', borderColor: '#20AA67' },
  upcoming: { badgeColor: 'tw-bg-[#4E4E4E]', badgeText: 'Upcoming', statusColor: 'tw-text-[#20AA67]', shadowVariant: 'grey', borderColor: '#4E4E4E' },
  available: { badgeColor: '', badgeText: '', statusColor: 'tw-text-[#20AA67]', shadowVariant: 'blue', borderColor: '#2D5EFF' },
  in_progress: { badgeColor: 'tw-bg-[#00BFBF]', badgeText: 'In Progress', statusColor: 'tw-text-[#20AA67]', shadowVariant: 'mint', borderColor: '#00BFBF' },
  claimable: { badgeColor: '', badgeText: '', statusColor: 'tw-text-[#20AA67]', shadowVariant: 'blue', borderColor: '#2D5EFF' },
};
